import { useEffect } from 'react';

import { ANALYTIC_EVENTS, Analytics } from 'analytics/Analytics';
import { SEARCH_PARAMS } from 'constants/search-params';
import { useGetCertQuery } from 'store/payment/service';
import { getQueryParams } from 'utils';

const useGetCert = () => {
  const { data: cert, isSuccess, isError, error } = useGetCertQuery(null);

  useEffect(() => {
    if (isSuccess) {
      Analytics.sentEvent(ANALYTIC_EVENTS.getCertSuccess);
    }

    if (isError && error) {
      Analytics.sentEvent(ANALYTIC_EVENTS.getCertError, {
        transaction_id: getQueryParams(SEARCH_PARAMS.ID),
        message: JSON.stringify(error),
      });
    }
  }, [error, isError, isSuccess]);

  return {
    cert,
  };
};

export { useGetCert };
